export type CyproEnvironment = 'dev' | 'staging' | 'demo' | 'production' | 'local'

/**
 * Reads a value from `window.__RUNTIME_FLAGS__` (substituted at container start by Caddy) and falls
 * back to the build-time `VITE_*` var. Treats a missing value, an empty string and the unsubstituted
 * `%placeholder%` alike as "no runtime value available" — see app/public/runtime-flags.js.
 */
export function readRuntimeValue(runtimeValue: string | undefined, envValue: string | undefined): string {
  if (runtimeValue && !runtimeValue.startsWith('%')) return runtimeValue
  return envValue || ''
}

export function readRuntimeFlag(runtimeValue: string | undefined, envValue: string | undefined): boolean {
  return readRuntimeValue(runtimeValue, envValue) === 'true'
}

function readRuntimeEnvironment(): string {
  return readRuntimeValue(window.__RUNTIME_FLAGS__?.environment, import.meta.env.VITE_CYPRO_ENVIRONMENT)
}

export function useCurrentEnv(): CyproEnvironment {
  const value = readRuntimeEnvironment().toLowerCase().trim() as CyproEnvironment
  if (['dev', 'staging', 'demo', 'production'].includes(value)) return value

  return 'local'
}

export function useIsDevEnv() {
  const env = useCurrentEnv()

  return env === 'local' || env === 'dev'
}
